import { PageLayout } from '@psyomics/ui-components';

import { CheckInContent } from '../../../features/survey/check-in-content/check-in-content';

const Home = () => {
  return (
    <PageLayout>
      <CheckInContent />
    </PageLayout>
  );
};

export { Home };
